module.exports = __webpack_require__.p + "6783ec54a5a9aea75aa5ef40143acd4b.mp4";